import {Component, Injector} from '@angular/core';
import {ApiResponse} from '../../../../../Services/Api/base-api.service';
import {WidgetDataControllerComponent} from '../../../../Controller/widget-data-controller-component';
import {DocumentsReviewApiService} from '../../../../../Services/Api/Documents-review/documents-review-api.service';
import {GeneralExpenseSimpleDto} from '../../../../../Models/Documents-review/general-expense-simple';
import {ExpensesReviewFilters} from '../../../../../Models/Documents-review/expenses-review-filters.model';

@Component({
  selector: 'app-expenses-review-widget',
  templateUrl: './expenses-review-widget.component.html',
  styleUrls: ['./expenses-review-widget.component.scss'],
  standalone: false,
})
export class ExpensesReviewWidgetComponent extends WidgetDataControllerComponent<number> {

  override fakeData: number = 1;

  get widgetData(): number {
    return this.data || this.data === 0 ? this.data : this.fakeData;
  }

  constructor(
    protected override injector: Injector,
    protected documentsReviewService: DocumentsReviewApiService,
  ) {
    super(injector, documentsReviewService);
  }


  /**
   * Obtener el número de gastos por revisar
   *
   */
  override setData(data: GeneralExpenseSimpleDto[]) {
    this.data = data.filter((item) => item.pendiente_ocr || item.error_ocr).length;
  }


  /**
   * Obtener datos
   *
   */
  getData(): Promise<ApiResponse> {
    const storeId: number = this.widgetsManager.filters ? this.widgetsManager.filters.local?.id : 0;
    return this.documentsReviewService.getGeneralExpensesSimples(ExpensesReviewFilters.forReview(storeId));
  }

}
